import React from 'react'
import moment from 'moment'
import _ from 'lodash'

const UserCard = ({ user, planSubscription }) => {

  if (!user) return null
  const displayName = (user.name || '').trim()
  const initials = displayName
    ? displayName.substring(0, 2).toUpperCase()
    : ''
  const profileImage = user.profile_picture
  const getProfileImage = () => {

    if (profileImage) {
      return (
        <img
          src={profileImage}
          alt={displayName}
        />
      )
    }
    return (
      <div className="product-user-initials">
        {initials}
      </div>
    )
  }
  const renderSubscription = () => {
    if (!planSubscription) return null
    const status = planSubscription.status?.toLowerCase()
    return (
      <div className="product-user-plan">
        <div>
          Plan: {planSubscription.product_name}
        </div>
        {planSubscription.end_time && (
          <div className="product-user-expiry">

            {status === 'active'
              ? 'Ends on '
              : 'Expired on '}
            {moment
              .utc(planSubscription.end_time)
              .local()
              .format('DD MMM YYYY, hh:mm A')}

          </div>
        )}
      </div>
    )
  }
  return (
    <div className="product-user-card-left">
      <div className="product-user-avatar">
        {getProfileImage()}
      </div>
      <div className="product-user-details">
        <div className="product-user-name">
          {user.name}
          {user.user_role && (
            <span className="product-user-role">
              {' '}[{_.startCase(user.user_role)}]
            </span>
          )}
        </div>
        <div className="product-user-email">
          {user.email}
        </div>
        {renderSubscription()}
      </div>
    </div>
  )
}
export default UserCard